import React from "react";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import "./AttendanceKpiCard.css";

function AttendanceKpiCard({ title, value, icon, color = "#007bff" }) {
  return (
    <Card className="kpi-card" style={{ borderLeft: `4px solid ${color}` }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" component="h3" style={{ color: color }}>
              {value}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <div
              className="kpi-icon"
              style={{ color: color, fontSize: "48px", textAlign: "right" }}
            >
              {icon}
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default AttendanceKpiCard;
